<template>
  <div class="main pl-4" v-if="this.availablePhases.length > 0">
    <div class="title mb-3">CLASSIFICA BUTLER</div>
    <b-container class="my-4">
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Fase</b-col>
        <b-col cols="4"><!--***-->Serie</b-col>
        <b-col cols="4"><!--***-->Girone</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedPhase" :options="availablePhases"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSerie" :options="availableSeries"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSector" :options="availableSectors"></combo-or-label>
        </b-col>
      </b-row>
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Sessione</b-col>
        <b-col cols="4"><!--***-->Round</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedSession" :options="availableSessions"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedRound" :options="availableRounds"></combo-or-label>
        </b-col>
      </b-row>
    </b-container>

    <b-tabs class="rank">
      <b-tab v-for="[type, rank] in Object.entries(ranksToBeShown)" :title="rank.RankType === 0 ? 'Classifica di sessione' : 'Classifica cumulata'">
        <b-table :fields="fieldsToBeShown" :items="rank.Rank" small striped :key="type" class="figbHeader">
          <template #cell(TeamName)="{item, value}">
            <div>{{ value }}</div>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>

import ComboOrLabel from "../components/lib/ComboOrLabel";
import {mapGetters} from "vuex";

export default {
  name: 'ButlerRanks',
  components: {ComboOrLabel},
  data() {
    return {
      selectedPhase: 1,
      selectedSerie: -1,
      selectedSector: -1,
      selectedSession: -1,
      selectedRound: -1,
      currentDetailsTable: -1
    }
  },
  computed: {
    ...mapGetters({
      butlerRanks: 'ranks/butlerRanks',
      currentRound: 'tournament/currentRound',
      teamPlayers: 'players/teamPlayers',
    }),
    ranksToBeShown() {
      if (this.selectedRound === -1) {
        return [];
      }

      return this.butlerRanks
          ?.Phases[this.selectedPhase]
          ?.Series[this.selectedSerie]
          ?.Groups[this.selectedSector]
          ?.Sessions[this.selectedSession]
          ?.Rounds[this.selectedRound]
          ?.Ranks ?? {};
    },
    availablePhases() {
      return Object.keys(this.butlerRanks?.Phases ?? {}).sort((a, b) => a - b);
    },
    availableSeries() {
      return Object.keys(
          this.butlerRanks.Phases[this.selectedPhase]?.Series ?? {}
      ).sort((a, b) => a - b);
    },
    availableSectors() {
      return Object.keys(
          this.butlerRanks
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups ?? {}
      ).sort((a, b) => a - b);
    },
    availableSessions() {
      if (this.selectedSector === -1) {
        return [];
      }
      return Object.keys(
          this.butlerRanks
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions ?? {}
      ).sort((a, b) => a - b);
    },
    availableRounds() {
      if (this.selectedSession === -1) {
        return [];
      }
      return Object.keys(
          this.butlerRanks
              ?.Phases[this.selectedPhase]
              ?.Series[this.selectedSerie]
              ?.Groups[this.selectedSector]
              ?.Sessions[this.selectedSession]
              ?.Rounds ?? {}
      ).sort((a, b) => a - b);
    },
    fieldsToBeShown() {
      return [
        {
          key: 'Position',
          label: '#'
        },
        {
          key: 'FullName',
          label: 'Giocatore'
        },
        {
          key: 'Points',
          label: 'Pt.',
          formatter: val => Math.round(val * 100) / 100
        },
        {
          key: 'PlayedBoards',
          label: 'Brd.'
        }
      ];
    }
  },
  methods: {
    openDetails(number) {
      this.currentDetailsTable = number;
    },
    closeDetails() {
      this.openDetails(-1);
    },
    getPlayersOfTeam(teamId) {
      return Object.values(this.teamPlayers).filter(plr => plr.Team === teamId).map(plr => plr.Name)
    }
  },
  watch: {
    selectedSession() {
      this.closeDetails();
    },
    selectedRound() {
      this.closeDetails();
    }
  }
};
</script>

<style scoped>
.nsText {
  color: #2661CE;
  font-weight: bold;
}

.ewText {
  color: #DC143C;
  font-weight: bold;
}

.impsResult {
  font-size: 2rem;
}

/deep/ .table > tbody > tr > td {
  vertical-align: middle;
}


>>> .figbHeader thead {
  color: #3396B8;
  background-color: white;
}


>>> .rank .nav-link {
  background-color: white;
  color: #AAAAAA;
  border-top-right-radius: 10px !important;
}


>>> .active {
  color: #1B708D !important;
}


.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}
</style>
